import { Button, Grid, Stack, TextField, Typography } from '@mui/material';
import * as React from 'react';
import ImageModal from '../Components/ImageModal';
import { useState } from 'react';
import SnackBar from '../../General/SnackBar';
import { GetTransactionRecipt } from 'API/DS_Wallet/api';
import BackdropLoader from '../../General/Loader';









export default function RequestData(props) {
  console.log("props", props);
  const [fileType,setFileType]=useState(null);
  const[Image,setImage] = useState(null);
  const [OpenImage, setOpenModal] = useState(false);
  const [AlertMessage,setAlertMessage]=useState(null)
  const [AlertType,setAlertType]=useState(null)
  const [AlertOpen,setAlertOpen]=useState(false)
  const [isLoading,setIsLoading]=useState(false)


  const fields_data = {

    "cash": [
      {
        name: 'fia_bank',
        display_name: "Fia Bank",
        type: 'text',
        value: 'SBI',
        disabled: true,
        required: false
      },
      {
        name: 'fia_acc_no',
        display_name: "Fia Account",
        type: 'text',
        value: '32541170333',
        disabled: true,
        required: false
      },

      {
        name: 'total_amount',
        display_name: "Amount",
        type: 'text',

        disabled: true,
        required: false
      },
      {
        name: 'hardware_amount',
        display_name: "Hardware Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'signon_amount',
        display_name: "Signon Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'transfer_deposit_date',
        display_name: "Transfer Date",
        type: 'date',
        value: null,
        disabled: false,
        required: true,
        maxDate: new Date()
      },
     
      {
        name: 'branch_location',
        display_name: "Bank Location",
        type: 'text',
        value: null,
        disabled: false,
        regex: /^[A-Za-z]*$/,
        required: true
      },
      {
        name: 'branch_code',
        display_name: "Branch Code",
        type: 'text',
        value: null,
        disabled: false,
        regex: /^([A-Za-z0-9 ]*|)$/,
        required: true
      },
      {
        name: 'branch_city',
        display_name: "City",
        type: 'text',
        value: null,
        disabled: false,
        regex: /^[A-Za-z]*$/,
        required: true
      },

      {
        name: 'remarks',
        display_name: "Remarks",
        type: 'text',
        value: null,
        disabled: false,
        required: false
      },
      {
        name: 'bank_recipt',
        display_name: "Bank / Txn Receipt",
        type: 'document',
        value: null,
        disabled: false,
        required: true
      }

    ],
    "NEFT": [
      {
        name: 'fia_bank',
        display_name: "Fia Bank",
        type: 'text',
        value: 'SBI',
        disabled: true,
        required: false
      },
      {
        name: 'fia_acc_no',
        display_name: "Fia Account",
        type: 'text',
        value: '32541170333',
        disabled: true,
        required: false
      },

     
      {
        name: 'total_amount',
        display_name: "Total Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'hardware_amount',
        display_name: "Hardware Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'signon_amount',
        display_name: "Signon Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'transfer_deposit_date',
        display_name: "Transfer Date",
        type: 'date',
        value: null,
        disabled: false,
        required: true,
        maxDate: new Date()
      },
      {
        name: 'bank_name',
        display_name: "Bank Name",
        type: 'select',
        disabled: false,
        required: true
      },
     
      {
        name: 'transaction_no',
        display_name: "Txn Ref No",
        type: 'text',
        value: null,
        disabled: false,
        regex: /^([A-Za-z0-9 ]*|)$/,
        required: true
      },
      {
        name: 'remarks',
        display_name: "Remarks",
        type: 'text',
        value: null,
        disabled: false,
        required: false
      },

    ],
    "IMPS": [
      {
        name: 'fia_bank',
        display_name: "Fia Bank",
        type: 'text',
        value: 'SBI',
        disabled: true,
        required: false
      },
      {
        name: 'fia_acc_no',
        display_name: "Fia Account",
        type: 'text',
        value: '32541170333',
        disabled: true,
        required: false
      },


      {
        name: 'total_amount',
        display_name: "Total Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'hardware_amount',
        display_name: "Hardware Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'signon_amount',
        display_name: "Signon Amount",
        type: 'text',
        disabled: true,
        required: false
      },
      {
        name: 'transfer_deposit_date',
        display_name: "Transfer Date",
        type: 'date',
        value: null,
        disabled: false,
        required: true,
        maxDate: new Date()
      },

      {
        name: 'transaction_no',
        display_name: "IMPS Ref No",
        type: 'text',
        value: null,
        disabled: false,
        regex: /^([A-Za-z0-9 ]*|)$/,
        required: true
      },
      {
        name: 'remarks',
        display_name: "Remarks",
        type: 'text',
        value: null,
        disabled: false,
        required: false
      },

    ],
  }

  const handleOpenModal=()=>{
    setOpenModal(true)
  }

  const handleAlertOpen=(message,type)=>{
    setAlertMessage(message)
    setAlertType(type)
    setAlertOpen(true)
  }

  const handleAlertClose=()=>{
    setAlertOpen(false)
  }

  const handleCloseImage=()=>{
    setOpenModal(false)
  }

  const handleImageGet=()=>{
    GetTransactionRecipt(props.userDetails.request_id,setImage,handleOpenModal,handleAlertOpen,setFileType,setIsLoading)
  }

  return (

    props && props.userDetails && fields_data[props.userDetails.transaction_type] ?
      <Grid container spacing={2}>
            <BackdropLoader open={isLoading}/>
            <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleAlertClose}/>
            <ImageModal fileType={fileType} image={Image} open={OpenImage} handleClose={handleCloseImage} />
            {
          fields_data[props.userDetails.transaction_type].map((item, index) => (
            <Grid item xl={4} lg={4} md={6} sm={12} sx={12} key={index}>
              {
                item.type === 'document' ?
                  <Stack alignItems="flex-start">
                    <Typography>{item.display_name}</Typography>
                    <Button sx={{ width: 'fit-content' }} variant='contained' size='small' color='secondary' onClick={()=>handleImageGet()}>view</Button>
                  </Stack>
                  :
                  <TextField
                    id="outlined-basic"
                    label={item.display_name}
                    variant="outlined"
                    value={props.userDetails[item.name] ? props.userDetails[item.name] : ""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      readOnly: true
                    }}
                    fullWidth
                  />
              }


            </Grid>
          ))
        }

      </Grid>
      :
      <Grid container>
        <Typography>Loading...</Typography>
      </Grid>

  )
}
